import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { popReturnTo } from '@maxus/website/utils'

import { exchangeTicket } from './exchange-ticket'

export const useTicketExchange = (): { exchanging: boolean } => {
  const navigate = useNavigate()
  const [exchanging, setExchanging] = useState(() => {
    const params = new URLSearchParams(window.location.search)
    // desktop=1 为桌面登录回跳：交给 use-desktop-login-relay 走深链接回传，浏览器内不消费 ticket。
    return params.has('ticket') && params.get('desktop') !== '1'
  })

  useEffect(
    () => {
      const params = new URLSearchParams(window.location.search)
      const ticket = params.get('ticket')
      if (!ticket) return
      // 桌面登录回跳：不在外部浏览器内换 token（会把 token 落到一次性浏览器且消费掉 ticket），
      // 改由 relay 经深链接把 ticket 回传 Electron 换取。
      if (params.get('desktop') === '1') return

      let cancelled = false
      let returnTo: string | null = null

      const exchange = async () => {
        try {
          await exchangeTicket(ticket)
          if (cancelled) return
          /**
           * 取出登录时暂存的 returnTo，跳回原路径
           */
          returnTo = popReturnTo()
        } catch (err) {
          console.error('[ticket-exchange] failed:', err)
        } finally {
          /**
           * hash router 下真实 search 只用于承载后端回调透传的 ticket，消费后整段丢弃。
           * 不能只删 ticket、保留其余真实 search 参数——那些参数（如 scope）会被拼到 `#` 前，
           * 落在真实 URL 上：既位置错误（应在 hash 内），又对 useSearchParams(hash 内 search) 不可见，
           * 且 hash 路由跳转永远不会清它，从而粘住形成 `/?scope=owned#/projects` 这类脏 URL。
           * 站内目标路径由 returnTo（hash）恢复，无需保留任何真实 search。
           */
          const cleanUrl = window.location.pathname + window.location.hash
          window.history.replaceState(window.history.state, '', cleanUrl)
          if (returnTo && !cancelled) {
            navigate(returnTo, { replace: true })
          }
          if (!cancelled) setExchanging(false)
        }
      }

      void exchange()
      return () => {
        cancelled = true
      }
    },
    [navigate],
  )

  return { exchanging }
}
